import api from './client';

// Tax Reserves API
export const taxReservesAPI = {
  getAll: (entityId) => api.get('/tax-reserves', { params: { entity_id: entityId } }),
  vatPosition: () => api.get('/tax-reserves/vat-position'),
  syncVat: () => api.put('/tax-reserves/vat-position/sync'),
  linkAccount: (reserveId, bankAccountId) => api.put(`/tax-reserves/${reserveId}/link-account`, null, { params: { bank_account_id: bankAccountId ?? '' } }),
  sufficiency: (entityId) => api.get('/tax-reserves/sufficiency', { params: { entity_id: entityId } }),
  // P&L-based estimator
  getEstimated: (entityId, year) => api.get('/tax-reserves/estimated', { params: { entity_id: entityId, year } }),
  getRates: (entityId) => api.get('/tax-reserves/rates', { params: { entity_id: entityId } }),
  updateRates: (entityId, body) => api.put('/tax-reserves/rates', body, { params: { entity_id: entityId } }),
};

// Reserves Waterfall API
export const reservesWaterfallAPI = {
  get: (entityId = 'br_ltd') => api.get('/admin/reserves/waterfall', { params: { entity_id: entityId } }),
};

// BR OS Tax Reserves API
export const brosTaxReservesAPI = {
  getRules: () => api.get('/bros/tax-reserves/rules'),
  updateRules: (params) => api.put('/bros/tax-reserves/rules', null, { params }),
  runAccrual: () => api.post('/bros/tax-reserves/accrue'),
  getBalances: () => api.get('/bros/tax-reserves/balances'),
  getLedger: () => api.get('/bros/tax-reserves/ledger'),
  getDiagnostics: () => api.get('/bros/tax-reserves/diagnostics'),
  // Weekly operation
  runWeekly: () => api.post('/bros/tax-reserves/weekly/run'),
  getLastWeeklyRun: () => api.get('/bros/tax-reserves/weekly/last-run'),
  // Sweep (tax bill payment)
  sweepPreview: (params) => api.post('/bros/tax-reserves/sweep/preview', null, { params }),
  sweepApply: (params) => api.post('/bros/tax-reserves/sweep/apply', null, { params }),
  // Draw (profit withdrawal)
  drawPreview: (params) => api.post('/bros/tax-reserves/draw/preview', null, { params }),
  drawApply: (params) => api.post('/bros/tax-reserves/draw/apply', null, { params }),
  // Per-payment view
  getPayments: (params) => api.get('/bros/tax-reserves/payments', { params }),
  updatePaymentStatus: (paymentId, status) =>
    api.patch(`/bros/tax-reserves/payments/${paymentId}/status`, null, { params: { status } }),
  bulkUpdateStatus: (params) =>
    api.post('/bros/tax-reserves/payments/bulk-status', null, { params }),
  // Per-country stats
  getCountryStats: () => api.get('/bros/tax-reserves/country-stats'),
  // Recompute reserves (admin)
  recomputePreview: () => api.post('/bros/tax-reserves/recompute/preview'),
  recomputeApply: () => api.post('/bros/tax-reserves/recompute/apply'),
  // Allocation trace (diagnostic)
  getAllocationTrace: (invoice) => api.get('/bros/tax-reserves/allocation-trace', { params: { invoice } }),
  // Supplier cost trace (diagnostic)
  getSupplierCostTrace: (booking) => api.get('/bros/tax-reserves/supplier-cost-trace', { params: { booking } }),
  // Country override config
  getCountryOverrides: () => api.get('/bros/tax-reserves/country-overrides'),
  updateCountryOverrides: (overrides) => api.put('/bros/tax-reserves/country-overrides', overrides),
  // Unattributed payments diagnostic
  getUnattributedPayments: () => api.get('/bros/tax-reserves/unattributed-payments'),
  // Partially-invoiced bookings diagnostic
  getPartiallyInvoiced: () => api.get('/bros/tax-reserves/partially-invoiced'),
  // VAT by month, collapsible, with the invoices and supplier documents behind it
  getVatMonths: (year) => api.get('/bros/tax-reserves/vat-months', { params: { year } }),
  // Month x country reserves + profitability with the payments behind them
  getCountryMonths: (params) => api.get('/bros/tax-reserves/country-months', { params }),
  // German master leases: rent paid per flat, and how much bookings covered
  getMasterLeases: (params) => api.get('/bros/master-leases', { params }),
  // Cash-basis waterfall: received -> VAT -> supplier cost -> corp tax -> draw
  getCashWaterfall: (params) => api.get('/bros/tax-reserves/cash-waterfall', { params }),
};

// Group aggregate across every entity: jurisdiction -> entity
export const taxReservesGroupAPI = {
  getGroupSummary: (year, displayCurrency) =>
    api.get('/tax-reserves/group-summary', { params: { year, display_currency: displayCurrency } }),
  // Month-end balances of the VAT / corporation tax vaults (Fan, 2026-10-28)
  getVaultBalances: (year) => api.get('/tax-reserves/vault-balances', { params: { year } }),
  getFxRates: () => api.get('/fx/rates'),
};

// Automated reserve transfers to Wise vaults (2026-09-27)
export const brosReserveTransfersAPI = {
  getStatus: () => api.get('/bros/reserve-transfers/status'),
  updateConfig: (body) => api.put('/bros/reserve-transfers/config', body),
  run: (params) => api.post('/bros/reserve-transfers/run', null, { params }),
  addHmrcCollection: (body) => api.post('/bros/reserve-transfers/hmrc-collections', body),
  removeHmrcCollection: (id) => api.delete(`/bros/reserve-transfers/hmrc-collections/${id}`),
};
